import { DecodeString } from ".";
export const GetCookieV2 = (key = "") => {
    let objectCookies = localStorage.getItem("clgv2");
    if (objectCookies !== "" && objectCookies !== null && objectCookies !== undefined) {
        let obj = JSON.parse(DecodeString(objectCookies));
        if (key === "All")
            return obj;
        else if(key==="Group")
            return obj?.Group;
        else if (key === "Customers")
            return obj?.Customers;
        else if (key === "Active")
            return obj?.Choose;
        else if (key === "Infochange") // Kho khách hàng hàng(mã con)
            return obj?.Infochange;
        return null;
    }
    else
        return window.location.href="/";
};